import { render } from "./pricesPP.vue?vue&type=template&id=5de2311a&scoped=true"
import script from "./pricesPP.vue?vue&type=script&lang=js"
export * from "./pricesPP.vue?vue&type=script&lang=js"

import "./pricesPP.vue?vue&type=style&index=0&id=5de2311a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5de2311a"]])

export default __exports__